module.exports = __webpack_public_path__ + "20250721160708/img/my_task.3c48296a.png";